// Vendor Libs
import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

// Hooks
import usePrevious from '../hooks/use-previous';

// Redux Actions
import {requestPassword, requestPasswordFormReset} from '../actions/request-password-actions';

function RequestPassword({children, email, formName, recordId, requestPassword, requestPasswordFormReset, status}) {
    const [showConfirm, setShowConfirm] = useState(false);
    const [requestCompleted, setRequestCompleted] = useState(false);
    const prevRecordId = usePrevious(recordId);

    useEffect(() => {
        if (recordId !== prevRecordId) {
            resetRequestPassword();
        }
    }, [recordId]);

    const handleConfirmClick = () => {
        requestPassword(formName, recordId, email).then(() => {
            setRequestCompleted(true);
            setShowConfirm(false);
        });
    };

    const handleResetClick = () => {
        resetRequestPassword(true);
    };

    const handleRequestPasswordClick = () => {
        setRequestCompleted(false);
        setShowConfirm(true);
    };

    const resetRequestPassword = (resetForm = false) => {
        requestPasswordFormReset(formName, resetForm);
        setRequestCompleted(false);
        setShowConfirm(false);
    };

    const shouldRenderRequestPasswordButton = () => !showConfirm && !requestCompleted;

    const shouldRenderConfirm = () => showConfirm || requestCompleted;

    const getRenderProps = () => ({
        showConfirm,
        requestCompleted,
        handleRequestPasswordClick,
        status,
        handleConfirmClick,
        handleResetClick,
        resetRequestPassword,
        shouldRenderConfirm,
        shouldRenderRequestPasswordButton,
    });

    return children ? children(getRenderProps()) : null;
}

RequestPassword.propTypes = {
    children: PropTypes.func,
    email: PropTypes.string,
    formName: PropTypes.string.isRequired,
    recordId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    requestPassword: PropTypes.func.isRequired,
    requestPasswordFormReset: PropTypes.func.isRequired,
    status: PropTypes.object,
};

const mapStateToProps = ({requestPassword = {}}) => ({
    status: requestPassword,
});

const mapDispatchToProps = {
    requestPassword,
    requestPasswordFormReset,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestPassword);
